module.exports = __webpack_public_path__ + "media/images/icon-arrow-ur@2x-a50140e4133a1cb2f1ba1f0add55f204.png";